var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 129,
    viewBox: "0 0 125 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.984 64.2408C123.984 99.1939 96.4271 127.482 62.4919 127.482C28.5567 127.482 1 99.1939 1 64.2408C1 29.2877 28.5567 1 62.4919 1C96.4271 1 123.984 29.2877 123.984 64.2408Z",
    stroke: "#5E6E82",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.4919,
    cy: 64.2408,
    rx: 55.7963,
    ry: 57.3579,
    fill: "#164FA1",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 45.5C38 32.5213 48.5213 22 61.5 22C74.4787 22 85 32.5213 85 45.5C85 58.4787 74.4787 69 61.5 69C48.5213 69 38 58.4787 38 45.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1892 79.4596C42.4509 76.8483 50.8031 76 61.5031 76C72.1812 76 80.5206 76.8449 86.7768 79.4427C93.4919 82.2311 97.6136 86.9683 99.8109 93.8584C100.627 96.419 98.6965 99 96.0275 99H26.9548C24.2968 99 22.3776 96.4305 23.1873 93.884C25.3779 86.9944 29.485 82.2552 36.1892 79.4596Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeProfileIcon);
export default __webpack_public_path__ + "static/media/employeeProfileIcon.6d046de4755a2afe94bb6d651a52bfa0.svg";
export { ForwardRef as ReactComponent };